import { render, staticRenderFns } from "./Crossroad.vue?vue&type=template&id=0dab95cc"
import script from "./Crossroad.vue?vue&type=script&lang=ts"
export * from "./Crossroad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports